module.exports = __webpack_public_path__ + "static/media/html-icon.525c06cd.svg";